import Header from "@/components/Header";
import Hero from "@/components/Hero";
import DemoShowcase from "@/components/DemoShowcase";
import SelectedAiWork from "@/components/SelectedAiWork";
import About from "@/components/About";
import Experience from "@/components/Experience";
import Skills from "@/components/Skills";
import Projects from "@/components/Projects";
import Education from "@/components/Education";
import Technologies from "@/components/Technologies";
import Footer from "@/components/Footer";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { useHead } from "@/hooks/useHead";
import { Helmet } from "react-helmet-async";
import { PersonJsonLd } from "@/components/SeoJsonLd";
import EN from "@/constants/en";
import { lazy, Suspense } from "react";

// Lazy load Contact component (heavy with forms and reCAPTCHA)
const Contact = lazy(() => import("@/components/Contact"));

const Index = () => {
    useScrollToTop();
    useHead(EN.META_TITLE, EN.META_DESCRIPTION, `${EN.SITE_URL}/`);

    return (
        <>
            <Helmet>
                <title>{EN.META_TITLE}</title>
                <meta name="description" content={EN.META_DESCRIPTION} />
                <link rel="canonical" href="https://marhaf-chamie.web.app/" />
                <meta name="robots" content="index,follow" />

                {/* Open Graph tags */}
                <meta property="og:title" content={EN.META_TITLE} />
                <meta property="og:description" content={EN.META_DESCRIPTION} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://marhaf-chamie.web.app/" />
                <meta property="og:image" content="https://marhaf-chamie.web.app/og-image.jpg" />
                <meta property="og:site_name" content="Marhaf Chamie Portfolio" />

                {/* Twitter Card tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={EN.META_TITLE} />
                <meta name="twitter:description" content={EN.META_DESCRIPTION} />
                <meta name="twitter:image" content="https://marhaf-chamie.web.app/og-image.jpg" />
                <meta name="twitter:creator" content={EN.META_TWITTER_HANDLE} />

                {/* Additional SEO tags */}
                <meta name="author" content={EN.META_AUTHOR} />
            </Helmet>
            <PersonJsonLd />
            <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow">
                    <Hero />
                    <DemoShowcase />
                    <SelectedAiWork />
                    <About />
                    <Experience />
                    <Skills />
                    <Projects />
                    <Education />
                    <Technologies />
                    <Suspense fallback={
                        <div className="py-20">
                            <div className="container mx-auto px-4">
                                <div className="text-center">Loading contact form...</div>
                            </div>
                        </div>
                    }>
                        <Contact />
                    </Suspense>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Index;
